package org.molap.dataframe

class ColumnStatistics(val min: Number?, val max: Number?, val sum: Double, val count: Long) {
    val mean: Double
        get() = sum / count

    override fun toString(): String {
        return "ColumnStatistics{" +
                "min=" + min +
                ", max=" + max +
                ", sum=" + sum +
                ", count=" + count +
                '}'
    }
}